import axios from 'axios';
import { logout } from './LoginActions';
import store from '../store';
import {ACCESS_TOKEN} from "../constants";
import {GET_USER_ACCESS_LEVEL_SUCCESS, LOGIN_SUCCESS} from "../constants/LoginConstants";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5132/api',
    withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

const handleLogout = async () => {
    try {
        await axios.post(
            `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5132/api'}/Token/Logout`,
            {},
            { withCredentials: true }
        );
    } catch (e) {
        console.warn('Logout request failed (might be already expired):', e.message);
    }

    store.dispatch(logout());
    window.location.href = '/sign-in';
};

api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                })
                    .then(token => {
                        originalRequest.headers['Authorization'] = `Bearer ${token}`;
                        return api(originalRequest);
                    })
                    .catch(err => Promise.reject(err));
            }

            isRefreshing = true;

            try {
                const refreshResponse = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL || 'http://localhost:5132/api'}/Token/Refresh`,
                    {},
                    { withCredentials: true }
                );

                const newAccessToken = refreshResponse.data?.data?.token;

                if (!newAccessToken) {
                    await handleLogout();
                    processQueue(new Error('No token'), null);
                    return Promise.reject(new Error('No access token received'));
                }

                localStorage.setItem(ACCESS_TOKEN, JSON.stringify(newAccessToken));
                api.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;

                store.dispatch({
                    type: LOGIN_SUCCESS,
                    payload: newAccessToken
                })

                store.dispatch({
                    type: GET_USER_ACCESS_LEVEL_SUCCESS,
                    payload: newAccessToken,
                    result: newAccessToken
                })

                processQueue(null, newAccessToken);

                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                return api(originalRequest);

            } catch (refreshError) {
                processQueue(refreshError, null);
                await handleLogout();
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default api;